import { useRouter } from 'next/router';
import { shallow } from 'zustand/shallow';

import { useUserPermissions } from '@/hooks/use-user-permissions';
import { useTelmaPortalStore } from '@/store/telma-portal-store';

export const useSaveBotVersionEnabled = () => {
    const { isBotEditor } = useUserPermissions();

    const router = useRouter();

    const botVersionId = (router.query.version_id as string) || '';

    const [currentBotVersion] = useTelmaPortalStore(
        (state) => [state.currentBotVersion],
        shallow,
    );

    const saveEnabled = isBotEditor && botVersionId === currentBotVersion;

    return saveEnabled;
};
